import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ChangePassword from "./pages/ChangePassword";
import VerifiedEmail from "./pages/VerifiedEmail";
import Unverified from "./pages/Unverified";
import Users from "./components/users/Users";
import Patents from "./components/patents/Patents";
import Research from "./components/research/Research";
import NewResearch from "./components/research/NewResearch";
import Consultancy from "./components/consultancy/Consultancy";
import NewConsultancy from "./components/consultancy/NewConsultancy";
import AppLayout from "./components/AppLayout/AppLayout";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import ErrorPage from "./pages/ErrorPage";
import Publications from "./components/publications/Publications";
import Patent from "./components/patents/Patent";
import Publication from "./components/publications/Publication";
import AuthLogin from "./pages/AuthLogin";
import AuthRegister from "./pages/AuthRegister";
import AuthForgot from "./pages/AuthForgot";

const theme = createTheme();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <BrowserRouter basename="/refolio">
            <Routes>
              <Route element={<AppLayout />}>
                <Route path="/" element={<AuthLogin />} />
                <Route path="/home" element={<Home />} />

                <Route path="/login" element={<AuthLogin />} />
                <Route path="/register" element={<AuthRegister />} />
                <Route path="/forgot" element={<AuthForgot />} />
                <Route path="/changepassword" element={<ChangePassword />} />
               
                <Route path="/verifyemail/:id" element={<VerifiedEmail />} />
                <Route path="/verify" element={<Unverified />} />

                <Route path="/users" element={<Users />} />
                <Route path="/publications" element={<Publications />} />
                <Route path="/patents" element={<Patents />} />
                <Route path="/research" element={<Research />} />
                <Route path="/consultancy" element={<Consultancy />} />

                <Route path="/insertPublications" element={<Publication />} />
                <Route path="/insertPatents" element={<Patent />} />
                <Route path="/insertResearch" element={<NewResearch />} />
                <Route path="/insertConsultancy" element={<NewConsultancy />} />
                <Route path="*" element={<ErrorPage />} />
              </Route>
            </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
